import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const VOTE_KEY = 'strawpoll-has-voted';
const VOTE_RESULT_KEY = 'strawpoll-voted-for';
const SCROLLED = 'Scrolled';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  private eventToken = '';
  private loggedIn = new Subject<void>();
  loggedIn$ = this.loggedIn.asObservable();

  constructor(private router: Router) { }

  /**
   * Setzt das Event-Token, das als Schlüssel-Suffix im SessionStorage verwendet wird.
   * Muss in LoginComponent und HomeComponent gesetzt werden.
   */
  public setEventToken(token: string): void {
    this.eventToken = token;
  }

  /**
   * Gibt das Schlüssel-Suffix zurück.
   * Nutzt das gesetzte Event-Token, falls vorhanden, sonst Fallback auf URL-basiertes Suffix.
   */
  private getTokenSuffix(): string {
    if (this.eventToken) {
      return this.eventToken;
    }
    return this.router.url.substring(this.router.url.lastIndexOf('/') + 1).split('?')[0];
  }

  signOut() {
    window.sessionStorage.clear();
  }

  public saveToken(token: string) {
    const suffix = this.getTokenSuffix();
    window.sessionStorage.removeItem(TOKEN_KEY + '-' + suffix);
    window.sessionStorage.setItem(TOKEN_KEY + '-' + suffix, token);
    this.loggedIn.next();
  }

  public getToken(): string {
    return sessionStorage.getItem(TOKEN_KEY + '-' + this.getTokenSuffix());
  }

  public saveUser(user) {
    const suffix = this.getTokenSuffix();
    window.sessionStorage.removeItem(USER_KEY + '-' + suffix);
    window.sessionStorage.setItem(USER_KEY + '-' + suffix, JSON.stringify(user));
  }

  public saveStrawpollVote(vote) {
    const suffix = this.getTokenSuffix();
    window.sessionStorage.setItem(VOTE_KEY + '-' + suffix, 'true');
    window.sessionStorage.setItem(VOTE_RESULT_KEY + '-' + suffix, vote);
  }

  public getStrawpollVoteResult() {
    return sessionStorage.getItem(VOTE_RESULT_KEY + '-' + this.getTokenSuffix());
  }

  public getHasStrawpollVoted() {
    return sessionStorage.getItem(VOTE_KEY + '-' + this.getTokenSuffix()) === 'true';
  }

  public saveScrolled() {
    window.sessionStorage.setItem(SCROLLED + '-' + this.getTokenSuffix(), 'true');
  }

  public getScrolled() {
    return sessionStorage.getItem(SCROLLED + '-' + this.getTokenSuffix());
  }

  /**
   * Liest die gespeicherte Login-Antwort.
   *
   * Der Schlüssel trägt dasselbe Event-Suffix wie beim Schreiben — ohne das kam hier
   * immer null zurück, obwohl die Antwort im sessionStorage lag.
   */
  public getUser() {
    const stored = sessionStorage.getItem(USER_KEY + '-' + this.getTokenSuffix());
    return stored ? JSON.parse(stored) : null;
  }
}
